<template>
  <input
    :id="id"
    v-maska:boundobject
    :value="boundobject"
    :placeholder="placeholder"
    :disabled="disabled"
    :data-maska="PHONE_MASK"
    type="tel"
    class="base-input base-input--black"
    @maska="replaceFirstEight"
    @paste="onPaste"
    @keydown="onKeydown"
  />
</template>

<script setup lang="ts">
import { vMaska } from 'maska/vue';

const PHONE_MASK = '+7 (###) ###-##-##';
const NON_DIGIT_CHARS = /\D/g;
const EIGHT = '8';
const DEFAULT_START_NUMBER = '+7 (';
const PLUS_SEVEN = '+7';

const backspaceCode = 'Backspace';
const phoneRegex = /[\d+]*/;
const keyC = 'KeyC';
const keyV = 'KeyV';
const keyA = 'KeyA';

defineProps({
  id: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  default: {
    type: String,
    default: '',
  },
});

const phone = defineModel<string>('phone');

const boundobject = ref('');

const normalizePhone = (phone: string) => {
  const updatedPhone = phone.replace(NON_DIGIT_CHARS, '');

  return updatedPhone ? `+${updatedPhone}` : '';
};

const emit = defineEmits(['change']);

const onKeydown = (e: KeyboardEvent) => {
  // meta для macOs
  const isCtrl = e.ctrlKey || e.metaKey;

  const [isDigit] = e.key?.match(phoneRegex) || [];
  const isBackspace = e.code === backspaceCode;
  const isCopy = isCtrl && e.code === keyC;
  const isPaste = isCtrl && e.code === keyV;
  const isSelectAll = isCtrl && e.code === keyA;

  if (isCopy || isBackspace || isPaste || isSelectAll) {
    return;
  }

  if (!isDigit) {
    e.preventDefault();
  }
};

const replaceFirstEight = (e: Event & { detail: { masked: string; unmasked: string } }) => {
  const maskedValue = e.detail.masked;
  const unmaskedValue = e.detail.unmasked;

  const isFirstEightCase = !phone.value && unmaskedValue === EIGHT;
  const isFirstSevenCase = !unmaskedValue && maskedValue === PLUS_SEVEN;

  const removeCase = !unmaskedValue && maskedValue !== PLUS_SEVEN && !!phone.value;

  if (isFirstEightCase || isFirstSevenCase) {
    boundobject.value = DEFAULT_START_NUMBER;
  } else if (removeCase) {
    boundobject.value = '';
  } else {
    boundobject.value = maskedValue;
  }

  phone.value = normalizePhone(boundobject.value);
  emit('change', phone.value);
};

const onPaste = (event: ClipboardEvent) => {
  const { clipboardData } = event;
  const target = event.target as HTMLInputElement;

  if (!clipboardData || !target) {
    return;
  }

  let pasteData = clipboardData.getData('text');

  pasteData = pasteData?.replace(NON_DIGIT_CHARS, '');

  if (pasteData.length > 10) {
    boundobject.value = pasteData?.slice(1);
  }

  phone.value = normalizePhone(boundobject.value);
};

defineExpose({ boundobject });
</script>
